// Custom properties set on an element through its ref: values only known while the app runs (a pane's
// dragged width, a previewed colour scheme), without an inline style attribute in the markup (TF-87).
export function cssVars(vars: Record<string, string>): (element: HTMLElement | null) => void {
  return (element) => {
    if (!element) return;
    for (const [name, value] of Object.entries(vars)) element.style.setProperty(name, value);
  };
}
